module.exports = __webpack_public_path__ + "img/rope-limited-access-atrium.620f57bb.jpg";